<h5 class="mb-3">Earnings</h5>
<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <div class="d-flex gap-2">
      <div class="border px-3 py-2 rounded">
        <span>Financial Year: </span>
        <span class="fw-medium">{{ financialYear }}</span>
      </div>

      <div class="border px-3 py-2 rounded">
        <span>Business Entity: </span>
        <span class="fw-medium">{{ businessEntity$ | async }}</span>
      </div>
    </div>
    <a target="_blank" [href]="imageBaseUrl + 'payroll-input.csv'">Inputs Template</a>
  </div>
</div>

<!-- Warning -->
<div class="warning-box my-3">
  <strong>Warnings (may affect your payroll run calculations)</strong><br />
  Investments are currently unlocked, all declared investments will be considered for this payroll –
  <a href="#">Click to Lock</a>
</div>

<!-- Payroll Controls -->
<div class="mb-3 d-flex justify-content-between align-items-center">
  <div>
    <label for="fileUploadInput" class="btn btn-success">Upload Inputs</label>
    <input
      appTrimInput
      type="file"
      id="fileUploadInput"
      (change)="onFileSelect($event)"
      accept=".csv"
      style="display: none"
    />
    <button (click)="syncLopDays()" class="btn btn-outline-primary ms-2">Sync LOP days</button>
    <!--<button class="btn btn-outline-primary ms-2">Sync Expenses and Travel Advances</button>-->
  </div>
  <div>
    <button (click)="onSubmit(false)" class="btn btn-light">Save For Later</button>
    <button
      class="btn btn-primary"
      (click)="onSubmit(true)"
      [disabled]="payrollBatchForm.invalid || payrollsFormArray.length === 0"
    >
      Process Inputs And Review
    </button>
  </div>
</div>

<!-- Employee Table -->
<div class="table-responsive" *ngIf="payrollsFormArray.length > 0">
  <form [formGroup]="payrollBatchForm">
    <div formArrayName="payrolls">
      <table class="table datatable">
        <thead class="thead-light">
          <tr>
            <th scope="col">Full Name</th>
            <th scope="col">Gross Salary</th>
            <th scope="col">Net Salary</th>
            <th scope="col">TDS After Cess</th>
            <th scope="col" *ngIf="showEsiColumn">ESI</th>
            <th scope="col">Effective From</th>
            <th scope="col">Key Settings</th>
            <th scope="col">Payslip</th>
            <!--<th scope="col">Detailed Calculation</th>-->
            <th scope="col">LOP Days</th>
            <th scope="col">Bonus</th>
            <th scope="col">Expenses</th>
            <th scope="col">Adjustments</th>
            <th scope="col">Rounding</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let payrollCtrl of payrollsFormArray.controls; let i = index"
            [formGroupName]="i"
            class="employee-row"
          >
            <td>
              <!--{{ currentIncomingPayrolls[i].employee.firstName || 'N/A' }}
              {{ currentIncomingPayrolls[i].employee.lastName }}-->
              <!--({{ getEmployeeSalary(i).employeeId }})-->

              <div class="d-flex align-items-center">
                <a
                  [routerLink]="[eps.hrm.employeePath, currentIncomingPayrolls[i].employee.id]"
                  class="avatar avatar-md"
                >
                  <!-- <img
                        [src]="employee.picture ? businessImages[employee.picture] : defaultImg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      /> -->
                  <ng-container *ngIf="currentIncomingPayrolls[i].employee.picture; else initials">
                    <img
                      [src]="imageBaseUrl + currentIncomingPayrolls[i].employee.picture"
                      class="img-fluid rounded-circle"
                      alt="img"
                      style="width: 100%; height: 100%; object-fit: cover"
                    />
                  </ng-container>

                  <ng-template #initials>
                    <span
                      class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                      style="width: 30px; height: 30px"
                      >{{
                        getInitials(
                          currentIncomingPayrolls[i].employee.firstName,
                          currentIncomingPayrolls[i].employee.lastName
                        )
                      }}</span
                    >
                  </ng-template>
                </a>
                <div class="ms-2">
                  <p class="text-dark mb-0">
                    <a [routerLink]="[eps.hrm.employeePath, currentIncomingPayrolls[i].employee.id]"
                      >{{ currentIncomingPayrolls[i].employee.firstName | capitalize }}
                      {{ currentIncomingPayrolls[i].employee.lastName | capitalize }}</a
                    >
                    <span class="fs-12"> ({{ currentIncomingPayrolls[i].employee.empId }})</span>
                  </p>
                  <span class="fs-12">{{
                    currentIncomingPayrolls[i].employee.designation?.designationName | capitalize
                  }}</span>
                </div>
              </div>
            </td>
            <td>
              {{
                payrollCtrl.get('grossSalary')?.value
                  | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN'
              }}
            </td>
            <td>
              {{
                payrollCtrl.get('netSalary')?.value | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN'
              }}
            </td>
            <td>
              <!-- {{
                payrollCtrl.get('tdsAfterCess')?.value
                  | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN'
              }} -->

              <input
                appTrimInput
                type="number"
                min="0"
                style="width: 200px"
                class="form-control form-control-sm"
                placeholder="TDS"
                formControlName="tdsAfterCess"
              />
            </td>
            <td *ngIf="showEsiColumn">
              <input
                appTrimInput
                type="number"
                min="0"
                style="width: 100px"
                class="form-control form-control-sm"
                placeholder="ESI"
                formControlName="esi"
                [readonly]="payrollCtrl.get('grossSalary')?.value >= 21000"
              />
              <!-- {{ payrollCtrl.get('esi')?.value }} -->
            </td>
            <td>
              {{
                getUpdatedEffectiveFromDate(
                  currentIncomingPayrolls[i].salary.effectiveFrom,
                  currentIncomingPayrolls[i].employee.joiningDate,
                  payPeriodStartDate
                ) | date: 'dd MMM yyyy'
              }}
            </td>
            <td>
              <button (click)="openModal(KeySettingsComponent, i)" class="btn bg-transparent">
                <i class="ti ti-eye"></i>
              </button>
            </td>
            <td>
              <button (click)="openModal(PayslipComponent, i)" class="btn bg-transparent">
                <i class="ti ti-eye"></i>
              </button>
            </td>
            <!--<td>
              <a href="#">View</a>
            </td>-->
            <td>
              <input
                appTrimInput
                type="number"
                class="form-control form-control-sm"
                style="width: 60px"
                placeholder="LOP"
                formControlName="lopDays"
                min="0"
                max="31"
                (input)="onLopInput(payrollCtrl)"
              />
              <div
                *ngIf="
                  payrollCtrl.get('lopDays')?.invalid &&
                  (payrollCtrl.get('lopDays')?.touched || payrollCtrl.get('lopDays')?.dirty)
                "
                class="text-danger small"
              >
                <span *ngIf="payrollCtrl.get('lopDays')?.errors?.['required']"
                  >LOP is required.</span
                >
                <span *ngIf="payrollCtrl.get('lopDays')?.errors?.['min']"
                  >LOP cannot be negative.</span
                >
                <span *ngIf="payrollCtrl.get('lopDays')?.errors?.['max']"
                  >LOP days exceed max.</span
                >
              </div>
            </td>
            <td>
              <input
                appTrimInput
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="bonus"
                (input)="onBonusInput(payrollCtrl)"
                [min]="0"
              />
              <div
                *ngIf="
                  payrollCtrl.get('bonus')?.invalid &&
                  (payrollCtrl.get('bonus')?.touched || payrollCtrl.get('bonus')?.dirty)
                "
                class="text-danger small"
              >
                <span *ngIf="payrollCtrl.get('bonus')?.errors?.['required']"
                  >Bonus is required.</span
                >
                <span *ngIf="payrollCtrl.get('bonus')?.errors?.['min']"
                  >Bonus cannot be negative.</span
                >
              </div>
            </td>
            <td>
              <input
                appTrimInput
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="expenses"
                (input)="onBonusInput(payrollCtrl)"
              />
              <div
                *ngIf="
                  payrollCtrl.get('expenses')?.invalid &&
                  (payrollCtrl.get('expenses')?.touched || payrollCtrl.get('expenses')?.dirty)
                "
                class="text-danger small"
              >
                <span *ngIf="payrollCtrl.get('expenses')?.errors?.['required']"
                  >Expenses are required.</span
                >
                <span *ngIf="payrollCtrl.get('expenses')?.errors?.['min']"
                  >Expenses cannot be negative.</span
                >
              </div>
            </td>
            <td>
              <input
                appTrimInput
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="adjustments"
              />
              <div
                *ngIf="
                  payrollCtrl.get('adjustments')?.invalid &&
                  (payrollCtrl.get('adjustments')?.touched || payrollCtrl.get('adjustments')?.dirty)
                "
                class="text-danger small"
              >
                Adjustments required.
              </div>
            </td>
            <td>
              <input
                appTrimInput
                type="number"
                class="form-control form-control-sm"
                placeholder="Add"
                formControlName="rounding"
              />
              <div
                *ngIf="
                  payrollCtrl.get('rounding')?.invalid &&
                  (payrollCtrl.get('rounding')?.touched || payrollCtrl.get('rounding')?.dirty)
                "
                class="text-danger small"
              >
                Rounding required.
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
</div>
